
import { APP_CONTENT_SIZE_SET, APP_FETCH_ABOUT_CURRENT_USER, APP_FETCH_ABOUT_CURRENT_USER_ERROR, APP_FETCH_ABOUT_CURRENT_USER_SUCCESS, APP_IMPERSONATE_USER, APP_IMPERSONATE_USER_ERROR, APP_IMPERSONATE_USER_SUCCESS, APP_IS_IE_SET, APP_IS_LOGGED_IN_UPDATE, APP_SHOW_IMPERSONATE_MODAL, APP_SNACKBAR_MESSAGE_SET, APP_WAKEUP_SUCCESS } from '../reduxActions/Types';
import _ from 'lodash';


const INITIAL_STATE = { 
  contentSize: {width:0,height:0},
  isIE: false,
  snackbarMessage : null,
  isMobile : false,
  isLoggedIn : false,
  aboutCurrentUser : null,
  fetchingAboutCurrentUser : false,
  aboutCurrentUserFetchError : false,
  shouldShowImpersonateModal:false,
  postingImpersonateUpdate:false,
  postingImpersonateError:false,
  wakeUpInfo:{},
};

export default (state = INITIAL_STATE, action) => {

  switch (action.type) {
    case APP_WAKEUP_SUCCESS:
        return {
            ...state,
            wakeUpInfo: action.payload,
        }
        case APP_IMPERSONATE_USER:
        return {
            ...state,
            postingImpersonateUpdate: true,
            postingImpersonateError: false
        }
        case APP_IMPERSONATE_USER_SUCCESS:
        return {
            ...state,
            postingImpersonateUpdate: false,
            postingImpersonateError: false
        }
        case APP_IMPERSONATE_USER_ERROR:
        return {
            ...state,
            postingImpersonateUpdate: false,
            postingImpersonateError: true
        }
    case APP_CONTENT_SIZE_SET:
        return {
            ...state,
            contentSize: action.payload,
            isMobile: action.payload.width < 800 ? true : false
        };
        case APP_IS_IE_SET:
        return {
            ...state,
            isIE: action.payload,
        };
        case APP_SHOW_IMPERSONATE_MODAL:
            return {
                ...state,
                shouldShowImpersonateModal: action.payload,
            }
        case APP_FETCH_ABOUT_CURRENT_USER_ERROR:
        return {
            ...state,
            fetchingAboutCurrentUser: false,
            aboutCurrentUserFetchError:true
        };
        case APP_FETCH_ABOUT_CURRENT_USER_SUCCESS:
        const aboutCurrentUser = {...action.payload,displayName:`${action.payload.firstName} ${action.payload.lastName}`}   
        aboutCurrentUser.isGbuAdmin =  !!_.find(action.payload.permissions,{scope:'GBU',hasRole:true}) ;
        aboutCurrentUser.isDeveloper =  !!_.find(action.payload.permissions,{name:'Developer',hasRole:true}) ;
        aboutCurrentUser.isOM =  action.payload.omFunctions.length > 0;
        aboutCurrentUser.isGbuLevelApprover =  !!_.find(action.payload.approvalRoles,{scope:'GBU'}) ;
        aboutCurrentUser.isProjectLevelApprover =  !!_.find(action.payload.approvalRoles,role => role.project) ;
        aboutCurrentUser.hasProjectPageAccess = aboutCurrentUser.isGbuAdmin || aboutCurrentUser.isAdmin || aboutCurrentUser.isOM || aboutCurrentUser.isGbuLevelApprover || aboutCurrentUser.isProjectLevelApprover;
        return {
            ...state,
            fetchingAboutCurrentUser: false,
            aboutCurrentUser,
             
        };
        case APP_FETCH_ABOUT_CURRENT_USER:
        return {
            ...state,
            fetchingAboutCurrentUser: true,
            aboutCurrentUserFetchError:false
        };
        case APP_IS_LOGGED_IN_UPDATE:
        return {
            ...state,
            isLoggedIn: action.payload
        };
        case APP_SNACKBAR_MESSAGE_SET:
            return {
                ...state,
                snackbarMessage: action.payload
            };
        case 'RESET_ALL_REDUX_STATE':
            return {
                ...INITIAL_STATE,
                aboutCurrentUser: state.aboutCurrentUser,
                contentSize: state.contentSize,
                isIE: state.isIE,
                isLoggedIn: state.isLoggedIn,
                wakeUpInfo: state.wakeUpInfo
            };
    default:
      return state;
  }
};
